import { render } from "./ListAgroExporters.vue?vue&type=template&id=33bcfebc"
import script from "./ListAgroExporters.vue?vue&type=script&lang=js"
export * from "./ListAgroExporters.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/customer/query/basic_containers/list_agro_exporters.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fcustomer%2Fquery%2Fbasic_containers%2FListAgroExporters.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__